const _getJSON = (productJSON = null) => {
  let json;
  if (productJSON != null) {
    json = productJSON;
  } else {
    json = getProductObject();
  }
  return json;
};

export const getFirstVariantId = (productJSON = null) => {
  const { variants } = _getJSON(productJSON);

  if (
    variants != null &&
    variants.length >= 1 &&
    variants[0].hasOwnProperty('id')
  ) {
    return variants[0].id;
  }

  return -1;
};

export const getProductPrice = (productJSON = null) => {
  const { price } = _getJSON(productJSON);

  if (price != null) {
    return price;
  }

  return -1;
};

export const setCurrentSelectedProductVariant = (variantID) => {
  window.embark.shop.product.current_variant = variantID;
};

export const getProductProperty = (property) => {
  return window.embark?.shop?.product !== 'undefined' ||
    window.embark?.shop?.product.hasOwnProperty(property)
    ? window.embark.shop.product[property]
    : -1;
};

export default function getProductObject() {
  const defaultValue = {};
  const element = document.querySelector('script[id|="ProductJson"]');

  if (element == null) {
    return defaultValue;
  }

  try {
    // TODO: Cache this value so we only need to read the DOM once
    // across calls.
    return JSON.parse(element.innerHTML);
  } catch (err) {
    return defaultValue;
  }
}
